/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Filter_No_MemoryInputs */



/**
* | output |
* | --- |
* | "No conversation info yet ({count})" |
*
* @param {Team_Filter_No_MemoryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_no_memory = /** @type {((inputs: Team_Filter_No_MemoryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_No_MemoryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Nog geen gespreksinfo (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pas encore d'infos d'entretien (${i?.count})`)
	return /** @type {LocalizedString} */ (`No conversation info yet (${i?.count})`)
});